import { TFunction } from 'i18next';
import { IUsers } from 'interfaces';

export const getUsersColumns = (t: TFunction) => [
  {
    title: t('Users.table.name'),
    dataIndex: 'name',
    key: 'name',
    width: '33%',
    sorter: (a: IUsers, b: IUsers) => {
      return (/^\d/.test(`${a.first_name} ${a.last_name}`) && /^\d/.test(`${b.first_name} ${b.last_name}`))
        ? parseInt(`${a.first_name} ${a.last_name}`, 10) - parseInt(`${b.first_name} ${b.last_name}`, 10)
        : `${a.first_name} ${a.last_name}`.localeCompare(`${b.first_name} ${b.last_name}`)
    },
  },
  {
    title: t('Users.table.role'),
    dataIndex: 'role',
    key: 'role',
    width: '20%',
  },
  {
    title: t('Users.table.status'),
    dataIndex: 'status',
    key: 'status',
    width: '22%',
  },
  {
    title: t('Users.table.entered_at'),
    dataIndex: 'entered_at',
    key: 'entered_at',
    width: '25%',
    sorter: (a: IUsers, b: IUsers) => a.entered_at && b.entered_at && a.entered_at - b.entered_at,
    ellipsis: true,
  },
  // {
  //   title: '',
  //   dataIndex: 'details',
  //   key: 'details',
  //   width: '5%',
  //   className: classes.textToCenter,
  // },
];

export const filtersForColumns = (t: TFunction, dataSource: any[], dataIndex: string, groupsSelectOptions: any, owner_id?: string) => {
  let availableFilters: { text: string, value: string }[] = [];

  if (dataIndex === 'role') {
    return groupsSelectOptions.map((filter: any) => ({text: filter.label, value: filter.value}));
  }

  if (dataIndex === 'status') {
    availableFilters = dataSource.reduce((acc: any, current: any) => {
      if (current.type) acc.accept = true;
      if (current.invite_status === 0) acc.awaiting = true;
      if (current.invite_status === 2) acc.rejected = true;
      // if (current.id === owner_id) acc.owner = true;
      return acc;
    }, {});
  }

  const filersArray: any[] = [];

  for (let key in availableFilters) {
    if (availableFilters[key]) filersArray.push({ text: t(`Users.table.statuses.${key}`), value: key })
  }

  return filersArray;
};


export const onCustomFilter = (value: any, record: any, dataIndex: string, owner_id?: string) => {
  
  if (dataIndex === 'role') {
    const currentRole = (record?.group && record?.group[0]) || record.group_id
    return currentRole === value
  };

  if (dataIndex === 'status') {
    switch(value) {
      case 'accept':
        return record.type === 'user';
      case 'awaiting':
        return record.invite_status === 0;
      case 'rejected':
        return record.invite_status === 2;
      // case 'owner':
      //   return record.id === owner_id;
    };
  };
};
